import React from "react";
import { Card } from "antd";
import "antd/dist/reset.css";

const LabelValueCard = ({ title, value }) => {
  return (
    <div className="rounded-2xl bg-white  p-4 sm:p-5 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0 w-full">
      <h2 className="text-base sm:text-lg md:text-xl font-semibold text-[#003B2D]">
        {title}
      </h2>
      <h2 className="text-base sm:text-lg md:text-xl font-semibold text-[#003B2D]">
        {value}%
      </h2>
    </div>
  );
};

export default LabelValueCard;
